module.exports = __webpack_public_path__ + "img/tpc-16.72f3dbcf.webp";